import { IconFn, IconSvg } from "../createIcon";

export const FileDownloadIcon: IconFn = ({ color = "white", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 22, height: 22 }} stroke={color} {...props}>
    <path stroke="none" d="M0 0h24v24H0z"></path>
    <path d="M14 3v4a1 1 0 001 1h4"></path>
    <path d="M17 21H7a2 2 0 01-2-2V5a2 2 0 012-2h7l5 5v11a2 2 0 01-2 2z"></path>
    <path d="M12 11L12 17"></path>
    <path d="M9 14L12 17 15 14"></path>
  </IconSvg>
);
